import { BaseService } from "./../../base";
export class ControlOrderService extends BaseService {
  static get entity() {
    return "control_order";
  }
  static get name() {
    return "control_order";
  }

  /**
   *
   * @param {string} data.rut es el rut del paciente (formato sin puntos ni guión)
   * @param {boolean} data.has_citation si la orden de control tiene siguiente citación
   * @param {boolean} data.without_citation si la orden de control no tiene siguiente citación
   * @param {number} data.service_node_id es el servicio de la consulta
   * @param {number} data.unity_node_id es la unidad de la consulta
   * @param {number} data.schedule_id es la agenda
   * @param { number } data.location_id es la locacion de la consulta asociada a la agenda
   * @returns {Promise<ControlOrder[]>}
   */
  static async filter(data, page = 1) {
    return this.submit("post", `${this.getApiUrlEntity(this.profile)}${this.entity}/filter?page=${page}`, this.name, data);
  }
  static async reportExcel(data) {
    return this.submit("post", `${this.getApiUrlEntity(this.profile)}${this.entity}/report`, null, data, {
      responseType: "blob",
    });
  }
}
